import React from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { styled } from "@mui/system";

const CenteredDialog = styled(Dialog)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ButtonContainer = styled(DialogActions)({
  justifyContent: "center",
});

const ConfirmationPopup = ({
  open,
  handleClose,
  handleConfirm,
  message,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
}) => {
  return (
    <CenteredDialog open={open} onClose={handleClose}>
      <DialogContent>{message}</DialogContent>
      <ButtonContainer>
        <Button
          sx={{ bgcolor: "#4CAF50", color: "white", width: "130px" }}
          onClick={handleClose}
        >
          {cancelButtonText}
        </Button>
        <Button
          sx={{ bgcolor: "#CF5C5C", color: "white", width: "130px" }}
          onClick={handleConfirm}
          color="error"
        >
          {confirmButtonText}
        </Button>
      </ButtonContainer>
    </CenteredDialog>
  );
};

export default ConfirmationPopup;
